const FOREX_COMMAND_PGK = {
    navTitle: "Forex",
    routerName: "ForexDocs",
    commandsDescription: "Rates, Charts, etc...",

    commandList: [
        {
            title: "Rates",
            routerRef: "pricerates",
            commandString: "!fx <Currency>",
            description: "Forex rates for USD/CAD/GBP/JPY",
            parameters: [
                { name: "Currency: ", desc: "The currency you want the rate for (must be one of these: USD/CAD/GBP/JPY)" },
            ],
            examples: [
                "!fx USD",
                "!fx CAD"
            ],
            type: "Forex", 
            shortcuts: ["none"]
        },
        {
            title: "USD/CAD Forex Chart",
            routerRef: "chart_usdcad",
            commandString: "!chart_usdcad",
            description: "5m USD/CAD Forex Chart",
            parameters: ["none"],
            examples: [
                "!chart_usdcad"
            ],
            type: "Forex", 
            shortcuts: ["none"]
        },
        {
            title: "USD/CHF Forex Chart",
            routerRef: "chart_usdchf",
            commandString: "!chart_usdchf",
            description: "5m USD/CHF Forex Chart",
            parameters: ["none"],
            examples: [
                "!chart_usdchf"
            ],
            type: "Forex", 
            shortcuts: ["none"]
        },
        {
            title: "USD/JPY Forex Chart",
            routerRef: "chart_usdjpy",
            commandString: "!chart_usdjpy",
            description: "5m USD/JPY Forex Chart",
            parameters: ["none"],
            examples: [
                "!chart_usdjpy"
            ],
            type: "Forex", 
            shortcuts: ["none"]
        },
        {
            title: "AUD/USD Forex Chart",
            routerRef: "chart_audusd",
            commandString: "!chart_audusd",
            description: "5m AUD/USD Forex Chart",
            parameters: ["none"],
            examples: [
                "!chart_audusd"
            ],
            type: "Forex", 
            shortcuts: ["none"]
        },
        {
            title: "NZD/USD Forex Chart",
            routerRef: "chart_nzdusd",
            commandString: "!chart_nzdusd",
            description: "5m NZD/USD Forex Chart",
            parameters: ["none"],
            examples: [
                "!chart_nzdusd"
            ],
            type: "Forex", 
            shortcuts: ["none"]
        },
        {
            title: "EUR/USD Forex Chart",
            routerRef: "chart_eurusd",
            commandString: "!chart_eurusd",
            description: "5m EUR/USD Forex Chart",
            parameters: ["none"],
            examples: [
                "!chart_eurusd"
            ],
            type: "Forex", 
            shortcuts: ["none"]
        },
        {
            title: "GBP/USD Forex Chart",
            routerRef: "chart_gbpusd",
            commandString: "!chart_gbpusd",
            description: "5m GBP/USD Forex Chart",
            parameters: ["none"],
            examples: [
                "!chart_gbpusd"
            ],
            type: "Forex", 
            shortcuts: ["none"]
        },
        {
            title: "USD/Ripple Forex Chart",
            routerRef: "chart_xrp",
            commandString: "!chart_xrp",
            description: "5m USD/Ripple Forex Chart",
            parameters: ["none"],
            examples: [
                "!chart_xrp"
            ],
            type: "Forex", 
            shortcuts: ["none"]
        },
    ]
}

// eslint-disable-next-line no-unused-vars

export {FOREX_COMMAND_PGK};